module.exports = __webpack_public_path__ + "static/media/maintainceReport.43b254b8.svg";